import React from 'react';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import { ResponsiveSidebarDialog, ModalTitle, ModalContent, StickyModalActions, PrimaryButton } from '@/styles/blocks';
import CarrierMappingRow from './CarrierMappingRow';

// The route fields the card has no room for: Middle Mile, Direct and the receiving warehouse.
// Edits go to the draft, so there's only Done.
const CarrierDetailsDialog = ({ mapping, name, carriersForLeg, allCarriers, onChange, disabled, onClose }) => (
    <ResponsiveSidebarDialog open={!!mapping} onClose={onClose}>
        <ModalTitle title="Carrier details" onClose={onClose} />
        <ModalContent width={520}>
            <Grid
                container
                direction="column"
                css={css`
                    flex-wrap: nowrap;
                    /* Room above the first field's floating label. */
                    padding: 8px 0 12px;
                `}
            >
                {mapping ? (
                    <CarrierMappingRow
                        mapping={mapping}
                        name={name}
                        carriersForLeg={carriersForLeg}
                        allCarriers={allCarriers}
                        onChange={onChange}
                        disabled={disabled}
                    />
                ) : null}
            </Grid>
        </ModalContent>
        <StickyModalActions>
            <Grid item />
            <Grid item>
                <PrimaryButton onClick={onClose}>Done</PrimaryButton>
            </Grid>
        </StickyModalActions>
    </ResponsiveSidebarDialog>
);

export default CarrierDetailsDialog;
